export const blockIconsTravelFamilyRestroomNew = (
	<span className='material-symbols-outlined'>family_restroom</span>
);
